module.exports = __webpack_public_path__ + "img/软性指标@2x.463389fa.png";